import React, { useEffect, useState } from 'react'
import { callPostApi } from '../api/ApiCaller';
import { PLAYER_TRANSACTION_HISTORY_GET } from '../api/ApiConst';
import toast from "react-hot-toast";
import { getCurrencySymbol } from '../utils/TextUtils';
import { useBalance } from '../BalanceContext';

const Account_Statement = () => {
    const { profileDetails: globalProfileDetails } = useBalance();
    // Store dates and type in separate variables
    const [startDate, setStartDate] = useState(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]); // 7 days ago
    const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]); // today
    const [transactionType, setTransactionType] = useState("Credit");
    const [transactions, setTransactions] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    // Handle start date change
    const handleStartDateChange = (value) => {
        if (value > endDate) {
            toast.error("Start date cannot be greater than end date", { id: "Toast" });
            return;
        }
        setStartDate(value);
    };

    // Handle end date change
    const handleEndDateChange = (value) => {
        if (value < startDate) {
            toast.error("End date cannot be less than start date", { id: "Toast" });
            return;
        }
        setEndDate(value);
    };

    // Handle transaction type change
    const handleTypeChange = (value) => {
        setTransactionType(value);
    };

    // API call when dates change
    useEffect(() => {
        if (startDate && endDate) {
            // Convert dates to timestamps
            const startTimestamp = new Date(startDate).getTime();
            const endTimestamp = new Date(endDate + 'T23:59:59').getTime(); // End of day

            callPostApi(PLAYER_TRANSACTION_HISTORY_GET.replace("{startDate}", startTimestamp).replace("{endDate}", endTimestamp), {
                pageSize: pageSize,
                pageNumber: pageNumber - 1
            }, {}, (response) => {
                setTransactions(response.responsePacket.data);
                setTotalPages(response.responsePacket.totalPages);
            });
        }
    }, [startDate, endDate, transactionType, pageSize, pageNumber]);


    return (
        <div className='main-div-content'>
            <div className="account-statement-filters">
                <span className="account-statement-filter-icon">
                    {/* SVG filter icon */}
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M3 5h18M6 10h12M10 15h4" stroke="#B0B0B0" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </span>

                {/* Dynamic date inputs */}
                <div className="date-inputs">
                    <input
                        className="account-statement-chip"
                        type="date"
                        value={startDate}
                        onChange={(e) => handleStartDateChange(e.target.value)}
                        max={endDate}
                    />

                    <input
                        className="account-statement-chip"
                        type="date"
                        value={endDate}
                        onChange={(e) => handleEndDateChange(e.target.value)}
                        min={startDate}
                    />
                </div>

                {/* <select value={transactionType} className="account-statement-chip" onChange={(e) => handleTypeChange(e.target.value)}>
                    <option value="Credit">Credit</option>
                    <option value="Debit">Debit</option>
                </select> */}
            </div>


            <div style={{ background: "#2F2F2F", borderRadius: "10px", overflow: "scroll" }} className="pb-2 px-2 account-statement-transactions">
                <table className="transaction-table table">
                    {transactions && transactions.length > 0 && <thead className=''>
                        <tr>
                            <th>Amount</th>
                            <th>Date</th>
                            <th>Customer Name</th>
                            <th>Customer Mobile</th>
                            <th>Payment Gateway</th>
                            <th>Payment Status</th>
                            <th>Transaction Ref ID</th>
                        </tr>
                    </thead>}
                    <tbody className='table-bordered'>
                        {transactions && transactions.length > 0 && transactions.map((transaction, index) => (
                            <tr key={index} className="transaction-row">
                                <td className={`transaction-amount  ${transaction.amount >= 0 ? 'positive' : 'negative'}`}>
                                    {getCurrencySymbol(globalProfileDetails?.currencyCode)} {Math.abs(transaction.amount).toFixed(2)}
                                </td>
                                <td className="transaction-date ">{new Date(transaction.createdAt).toLocaleDateString('pt-BR') + ' ' + new Date(transaction.createdAt).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) || 'N/A'}</td>
                                <td className="customer-name ">{transaction.customerName || 'N/A'}</td>
                                <td className="customer-mobile ">{transaction.customerMobile || 'N/A'}</td>
                                <td className="payment-gateway ">{transaction.paymentGateway || 'N/A'}</td>
                                {/* <td className="payment-status ">
                                    <span className={`status-badge  ${transaction.paymentStatus?.toLowerCase()}`}>
                                        {transaction.paymentStatus || 'N/A'}
                                    </span>
                                </td> */}
                                <td className="payment-status ">
                                    <span
                                        className={`status-badge ${transaction.paymentStatus?.toLowerCase()}`}
                                        style={{
                                            color: '#fff',
                                            color:
                                                (transaction.paymentStatus?.toLowerCase() === 'pending' || transaction.paymentStatus?.toLowerCase() === 'waiting') ? '#dc3545' : // red
                                                    (transaction.paymentStatus?.toLowerCase() === 'approved' || transaction.paymentStatus?.toLowerCase() === 'paid') ? '#28a745' : // green
                                                        // (transaction.paymentStatus?.toLowerCase() === 'paid' || transaction.paymentStatus?.toLowerCase() === 'paid') ? '#28a745' : // green
                                                        (transaction.paymentStatus?.toLowerCase() === 'rejected' || transaction.paymentStatus?.toLowerCase() === 'refused') ? '#ffc107' : // yellow
                                                            undefined
                                        }}
                                    >
                                        <span className="d-flex status">
                                            {(transaction.paymentStatus?.toLowerCase() === "rejected" || transaction.paymentStatus?.toLowerCase() === "refused") && <span><svg width="16" height="16" viewBox="0 0 16 16" style={{ verticalAlign: 'middle', marginRight: 4 }}>
                                                <circle cx="8" cy="8" r="8" fill="#b91c1c" />
                                                <line x1="5.5" y1="5.5" x2="10.5" y2="10.5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                                                <line x1="10.5" y1="5.5" x2="5.5" y2="10.5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                                            </svg></span>}
                                            {(transaction.paymentStatus?.toLowerCase() === "paid" || transaction.paymentStatus?.toLowerCase() === "approved") ? 'Approved' :
                                                (transaction.paymentStatus?.toLowerCase() === "waiting" || transaction.paymentStatus?.toLowerCase() === "pending") ? 'Pending' :
                                                    (transaction.paymentStatus?.toLowerCase() === "refused" || transaction.paymentStatus?.toLowerCase() === "rejected") ? 'Cancelled' : 'Pending'}
                                        </span>

                                    </span>
                                </td>
                                <td className="transaction-ref-id ">{transaction.transactionRefId || 'N/A'}</td>
                            </tr>
                        ))}
                        {transactions && transactions.length === 0 && (
                            <tr>
                                <td colSpan="6" className="text-center">No transactions found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div className='d-flex gap-4 mt-4 mb-4 justify-content-end'>
                <span className='text-white'>Items Per Page 10</span>
                <span className='text-white'>{pageNumber} of {totalPages}</span>
                <div className='d-flex gap-4 font-weight-bold'>
                    <span
                        onClick={() => pageNumber > 1 && setPageNumber(1)}
                        className={`h-16 w-16 text-white cursor-pointer ${pageNumber <= 1 ? 'opacity-50' : ''}`}
                        style={{ cursor: pageNumber <= 1 ? 'not-allowed' : 'pointer' }}
                    >
                        {"<<"}
                    </span>
                    <span
                        onClick={() => pageNumber > 1 && setPageNumber(pageNumber - 1)}
                        className={`h-16 w-16 text-white cursor-pointer ${pageNumber <= 1 ? 'opacity-50' : ''}`}
                        style={{ cursor: pageNumber <= 1 ? 'not-allowed' : 'pointer' }}
                    >
                        {"<"}
                    </span>
                    <span
                        onClick={() => pageNumber < totalPages && setPageNumber(pageNumber + 1)}
                        className={`h-16 w-16 text-white cursor-pointer ${pageNumber >= totalPages ? 'opacity-50' : ''}`}
                        style={{ cursor: pageNumber >= totalPages ? 'not-allowed' : 'pointer' }}
                    >
                        {">"}
                    </span>
                    <span
                        onClick={() => pageNumber < totalPages && setPageNumber(totalPages)}
                        className={`h-16 w-16 text-white cursor-pointer ${pageNumber >= totalPages ? 'opacity-50' : ''}`}
                        style={{ cursor: pageNumber >= totalPages ? 'not-allowed' : 'pointer' }}
                    >
                        {">>"}
                    </span>
                </div>
            </div>
        </div>
    )
}

export default Account_Statement